export default __webpack_public_path__ + "static/media/xy.b686c762.png";